<template>
  <div class="myOrder">
    <header-box />
    <div class="order_box">
      <p>我的订单</p>
      <div style="width: 300px; margin: 10px; display: flex">
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="order.OrderNo"
        />
        <div style="margin-left: 20px">
          <el-button @click="getOrderLis" plain>查询</el-button>
        </div>
      </div>
      <div class="order-box-header">
        <el-tabs v-model="order.states" @tab-click="handleClick">
          <el-tab-pane label="全部" :name="`1,2,3,4,5,6,7,8,9,10,11`">
            <from-box :setBillDetail="setBillDetail" :list="orderData" />
          </el-tab-pane>
          <el-tab-pane label="待审核" :name="`1,11`"
            ><from-box :setBillDetail="setBillDetail" :list="orderData"
          /></el-tab-pane>
          <el-tab-pane label="待付款" :name="`2`"
            ><from-box :setBillDetail="setBillDetail" :list="orderData"
          /></el-tab-pane>
          <el-tab-pane label="生产中" :name="`3,4`"
            ><from-box :setBillDetail="setBillDetail" :list="orderData"
          /></el-tab-pane>
          <el-tab-pane label="已发货" :name="'5,6'"
            ><from-box :setBillDetail="setBillDetail" :list="orderData"
          /></el-tab-pane>
          <el-tab-pane label="已完成" name="7"
            ><from-box :setBillDetail="setBillDetail" :list="orderData"
          /></el-tab-pane>
        </el-tabs>
      </div>
      <div class="btn">
        <button @click="prevClick">上一页</button>
        <button @click="nextClick">下一页</button>
      </div>
    </div>
  </div>
</template>
<script>
import headerBox from "../../components/box/headerbox.vue";
import fromBox from "../../components/box/fromBox.vue";
import { getOrderApi } from "../../api/http/order";
export default {
  components: {
    headerBox,
    fromBox,
  },
  data() {
    return {
      orderData: [],
      order: {
        states: `1,2,3,4,5,6,7,8,9,10,11`,
        ordertypes: "2,3",
        OrderNo: "",
        page: 1,
        size: 20,
      },
    };
  },
  created() {
    this.getOrderLis();
  },
  methods: {
    prevClick() {
    if(this.order.page>0){
        this.order.page--;
      this.getOrderLis();
    }else{
      
      this.order.page=1
      this.getOrderLis();
      this.$message({
        message:"已经是第一页了"
      })
    }
    },
    nextClick() {
      if (this.orderData.length != 0) {
        this.order.page++;
        this.getOrderLis();
      } else {
        this.$message({
          message: "已是最后一页了",
        });
      }
    },
    // 子组件调用方法
    setBillDetail() {
      this.getOrderLis();
    },
    // 头部事件
    handleClick(tab, event) {
      // if(this.order.states=='5,6'||this.order.states=='7'){
      //   this.order.stategroup=2
      // }else{
      //   this.order.stategroup=1
      // }
      this.getOrderLis();
    },
    getOrderLis() {
      getOrderApi.getOrderLlist(this.order).then((res) => {
        this.orderData = res.data.data;
        console.log(this.orderData)
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn{
display: flex;
justify-content: center;
button{
  margin: 5px;
}
}
.myOrder {
  .box {
    border: 1px solid #eee;
    height: 40vh;
    overflow-y: scroll;
  }

  .order_box {
    width: 90%;
    margin: auto;
    border: 1px solid #eee;
    margin-top: 1rem;
    .order-box-header {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #eee;
      padding: 5px;
      div {
        flex: 1;
        text-align: center;
      }
    }
    p {
      margin-left: 10px;
      font-weight: 700;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/my/myOrder.vue